import { Card, CardContent } from "@component/card";
import { Badge } from "@component/badge";
import { Button } from "@component/button";
import { TrashIcon } from "lucide-react";
import { Tooltip } from "@component/tooltip";
import { EmailTemplate } from "@type/setting";

interface TemplateListItemProps {
    template: EmailTemplate;
    isSelected: boolean;
    onSelect: (template: EmailTemplate) => void;
    onDelete?: (template: EmailTemplate) => void;
}

export default function TemplateListItem(props: TemplateListItemProps) {
    const handleDelete = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (props.onDelete && !props.template.is_default) {
            props.onDelete(props.template);
        }
    };

    return (
        <Card
            className={`rounded-lg cursor-pointer transition-colors hover:bg-gray-50 ${props.isSelected ? "ring-2 ring-blue-500" : ""
                }`}
            onClick={() => {
                props.onSelect(props.template);
            }}
        >
            <CardContent className="p-4">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2 flex-1 min-w-0">
                        <h4 className="font-medium text-gray-900 text-sm truncate">
                            {props.template.template_name}
                        </h4>
                        {props.template.is_default && (
                            <Tooltip
                                content={(
                                    <p className="text-sm">
                                        You can only edit Default templates.
                                    </p>
                                )}
                            >
                                <span className="inline-flex">
                                    <Badge
                                        className="text-xs bg-blue-100 text-blue-700 border-blue-200 hover:bg-blue-100 shadow-none flex-shrink-0"
                                        style={{
                                            paddingTop: "4px",
                                            paddingBottom: "4px",
                                            borderRadius: "1rem",
                                        }}
                                    >
                                        Default
                                    </Badge>
                                </span>
                            </Tooltip>
                        )}
                    </div>
                    {props.onDelete && !props.template.is_default && (
                        <Button
                            variant="ghost"
                            size="sm"
                            onClick={handleDelete}
                            className="h-8 w-8 p-0 text-gray-400 hover:text-red-600 hover:bg-red-50 flex-shrink-0"
                        >
                            <TrashIcon className="h-4 w-4" />
                        </Button>
                    )}
                </div>
            </CardContent>
        </Card>
    );
}
